export const FieldProperties = {
  FieldType: 'FIELD_TYPE',
  RequireMapImage: 'REQUIRE_MAP_IMAGE',
  BackgroundCropDimensions: 'BACKGROUND_CROP_DIMENSIONS',
  DateTimeFormat: 'DATE_TIME_FORMAT',
  FieldValidationErrorSettings: 'FIELD_VALIDATION_ERROR_SETTINGS'
};
